export default "__VITE_ASSET__CpPh7gcm__"